import Logger from '../fw/logger';


export default class ID3 {

  #rmp;

  constructor(rmp) {
    this.#rmp = rmp;
  }

  #processCues(event) {
    // on cuechange get activeCues
    let activeCues;
    if (event.type === 'cuechange') {
      Logger.print('meta', 'cuechange event');
      if (event && event.target && event.target.activeCues && event.target.activeCues.length > 0) {
        // we have activeCues data we can update UI
        activeCues = event.target.activeCues;
      }
    }
    if (!activeCues) {
      Logger.print('meta', 'no valid activeCues found on cuechange event');
      return;
    }
    this.#rmp.meta = {};
    this.#rmp.meta.type = 'id3';
    this.#rmp.meta.data = {};
    this.#rmp.meta.raw = [];
    const regexUrl = /http(s)?:.+\.(jpg|png|gif|avif)/;
    let url;
    for (let i = 0, len = activeCues.length; i < len; i++) {
      if (activeCues[i].value) {
        let cue = activeCues[i];
        // check that we can work with value otherwise move to next cue
        let value = cue.value;
        // add end/start for each meta
        if (typeof cue.startTime === 'number' && cue.startTime >= 0) {
          if (typeof this.#rmp.meta.data.start !== 'number' || this.#rmp.meta.data.start !== cue.startTime) {
            this.#rmp.meta.data.start = cue.startTime;
          }
        }
        if (typeof cue.endTime === 'number' && cue.endTime >= 0) {
          if (typeof this.#rmp.meta.data.end !== 'number' || this.#rmp.meta.data.end !== cue.endTime) {
            this.#rmp.meta.data.end = cue.endTime;
          }
        }
        // we can have key|data|info properties
        this.#rmp.meta.raw.push(value);
        switch (value.key) {
          case 'TALB':
            this.#rmp.meta.data.albumTitle = value.data.replace(/"/g, '');
            break;
          case 'TDRC':
            this.#rmp.meta.data.recordingTime = value.data.replace(/"/g, '');
            break;
          case 'TDRL':
            this.#rmp.meta.data.releaseTime = value.data.replace(/"/g, '');
            break;
          case 'TCOM':
            this.#rmp.meta.data.composer = value.data.replace(/"/g, '');
            break;
          case 'TCON':
            this.#rmp.meta.data.contentType = value.data.replace(/"/g, '');
            break;
          case 'TFLT':
            this.#rmp.meta.data.fileType = value.data.replace(/"/g, '');
            break;
          case 'TIT1':
            this.#rmp.meta.data.contentGroup = value.data.replace(/"/g, '');
            break;
          case 'TIT2':
            this.#rmp.meta.data.title = value.data.replace(/"/g, '');
            break;
          case 'TLEN':
            this.#rmp.meta.data.duration = value.data.replace(/"/g, '');
            break;
          case 'TPE1':
            this.#rmp.meta.data.artist = value.data.replace(/"/g, '');
            break;
          case 'TPE2':
            this.#rmp.meta.data.band = value.data.replace(/"/g, '');
            break;
          case 'TPE3':
            this.#rmp.meta.data.conductor = value.data.replace(/"/g, '');
            break;
          case 'TRSN':
            this.#rmp.meta.data.radioStationName = value.data.replace(/"/g, '');
            break;
          case 'TRSO':
            this.#rmp.meta.data.radioStationOwner = value.data.replace(/"/g, '');
            break;
          case 'TSRC':
            this.#rmp.meta.data.isrc = value.data.replace(/"/g, '');
            break;
          case 'WCOM':
            this.#rmp.meta.data.commercialInfo = value.data.replace(/"/g, '');
            break;
          case 'WCOP':
            this.#rmp.meta.data.copyrightInfo = value.data.replace(/"/g, '');
            break;
          case 'WXXX':
            if (value.info && regexUrl.test(value.info)) {
              this.#rmp.meta.data.url = value.info.replace(/"/g, '');
            } else if (value.data && regexUrl.test(value.data)) {
              this.#rmp.meta.data.url = value.data.replace(/"/g, '');
            }
            url = this.#rmp.meta.data.url.match(regexUrl);
            if (url && url[0]) {
              this.#rmp.meta.data.url = url[0];
            } else {
              delete this.#rmp.meta.data.url;
            }
            break;
          default:
            break;
        }
      }
    }
    if (this.#rmp.audioOnlyID3UI) {
      let description = '';
      if (this.#rmp.meta.data.artist) {
        description += this.#rmp.meta.data.artist;
        if (this.#rmp.meta.data.albumTitle) {
          description += ' - ' + this.#rmp.meta.data.albumTitle;
          if (this.#rmp.meta.data.recordingTime) {
            description += ' (' + this.#rmp.meta.data.recordingTime + ')';
          }
        }
      }
      let title = '';
      if (this.#rmp.meta.data.title) {
        title += this.#rmp.meta.data.title;
        if (this.#rmp.meta.data.duration) {
          title += ' (' + this.#rmp.meta.data.duration + ')';
        }
      }
      let poster = [''];
      if (url && url[0]) {
        poster = [url[0]];
      }
      this.#rmp.contentMetadataConfiguration = {
        description,
        poster,
        title
      };
    }
    this.#rmp.dispatch('meta');
    Logger.print(null, null, this.#rmp.meta);
  }

  #onAddTrack(event) {
    Logger.print('meta', 'addtrack event', event);
    if (event && event.track && event.track.kind && event.track.kind === 'metadata') {
      Logger.print('meta', 'addtrack event with metadata track', event.track);
      // in iOS track must not be in disabled mode to fire cuechange events
      let track = event.track;
      if (track.mode === 'disabled') {
        track.mode = 'hidden';
      }
      // if track is kind metadata (e.g. in this case ID3) we listen for cuechange
      // when cuechange event fires we can start looking for ID3 metadata
      track.addEventListener('cuechange', this.#processCues.bind(this));
    }
  }

  init() {
    try {
      this.#rmp.dom.video.textTracks.addEventListener('addtrack', this.#onAddTrack.bind(this));
    } catch (warning) {
      console.warn(warning);
    }
  }

}
